import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Popover from './Popover';
import { mainStore } from '../stores/MainStore';
import { userStore } from '../stores/UserStore';

export default observer(() => {
  const { t } = useTranslation();
  const onDismiss = () => mainStore.setIsFreeDeliveryPopover(false);

  return (
    <Popover isShow={mainStore.isFreeDeliveryPopover} onBackdropDismiss={onDismiss}>
      <div className="fs-21 fw-500">{t('congrats')}</div>
      <div className="fs-14 lh-20 mt-20">
        {t('cartBoard:congratsUser', { count: userStore.personalData.freeDeliveryDaysLeft })}
      </div>
      <div className="button _primary w-100p mt-32" onClick={onDismiss}>
        {t('understood')}
      </div>
    </Popover>
  );
});
